import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { EnableSignUpSessionRecording } from '~/constants/ff.posthog';
import { useFeatureFlag } from './useFeatureFlag';
import { usePosthog } from './usePosthog';

const REGISTRATION_PATH = '/registration';

export const useSignUpPosthogSessionRecording = () => {
  const location = useLocation();
  const posthog = usePosthog();
  const isRecordingRef = useRef(false);
  const isEnabled = useFeatureFlag(EnableSignUpSessionRecording);

  useEffect(() => {
    const shouldRecord = isEnabled && location.pathname.startsWith(REGISTRATION_PATH);

    if (shouldRecord && !isRecordingRef.current) {
      posthog.startSessionRecording();
      isRecordingRef.current = true;
    } else if (!shouldRecord && isRecordingRef.current) {
      posthog.stopSessionRecording();
      isRecordingRef.current = false;
    }
  }, [location.pathname, posthog, isEnabled]);

  // Stop recording on unmount only (separate effect to avoid stop/start flicker on route changes)
  // Ensure recording stops when the app is closed or terminated
  useEffect(() => {
    return () => {
      posthog.stopSessionRecording();
    };
  }, [posthog]);
};
